import pkg from '../package.json';

/**
 * What this build of the web app can say about itself, for «Приложение» — the
 * twin of the phone app's `build_info.dart`.
 *
 * The version is `package.json`'s. The day is baked in by `vite.config.ts` when the
 * bundle is built; a dev server has none, and says it does not know rather than
 * inventing a day.
 */
declare const __BUILD_DATE__: string;

export const appVersion: string = pkg.version;

export const buildDate: Date | null = (() => {
  const raw = typeof __BUILD_DATE__ === 'string' ? __BUILD_DATE__ : '';
  const at = raw ? new Date(`${raw}T12:00:00Z`) : null;
  return at && !Number.isNaN(at.getTime()) ? at : null;
})();

/** «25 сентября 2026» — the day in words, as the phone's `fullDate` writes it. */
export function fullDate(at: Date): string {
  return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
    .format(at)
    .replace(/\s*г\.?$/, '');
}
